// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * Identity Api
 * OpenAPI spec version: v1
 */

export type CommonDomainMarktsegment =
  (typeof CommonDomainMarktsegment)[keyof typeof CommonDomainMarktsegment];

export const CommonDomainMarktsegment = {
  Particulier: 'Particulier',
  Zakelijk: 'Zakelijk',
} as const;
